import * as React from 'react'
import { DownTime, DowntimePropertyName } from '../../../model/DownTime'
import { DateTimePicker } from '../../../common/DateTimePicker'
import ValidationMessageList from '../ValidationMessageList'

type Props = {
  downtimes?: DownTime[]
  newEvent: DownTime
  replaceDowntime: (downtime: DownTime) => void
  setInvalidDateValidationMessage: (downtime: DownTime, property: string) => void
}

type State = {
  timeOn: Date | undefined
}

export class DownTimeTimeOnInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      timeOn: props.newEvent.timeOn
    }
  }

  onBlur = (timeOn?: Date): void => {
    timeOn
      ? this.props.replaceDowntime({
          ...this.props.newEvent,
          timeOn: timeOn
        })
      : this.props.setInvalidDateValidationMessage(this.props.newEvent, DowntimePropertyName.TimeOn)
  }

  onChange = (timeOn?: Date): void => {
    this.setState({
      timeOn
    })
  }

  isTimeOnValid = (): boolean => {
    return (
      this.props.newEvent.GetAllValidationMessagesForProperty(DowntimePropertyName.TimeOn)
        .length === 0
    )
  }

  public render(): JSX.Element {
    return (
      <div className="form">
        <DateTimePicker
          onChange={this.onChange}
          onBlur={this.onBlur}
          value={this.state.timeOn}
          inputClass={this.isTimeOnValid() ? 'form-control is-valid' : 'form-control is-invalid'}
        />
        <ValidationMessageList
          property={DowntimePropertyName.TimeOn}
          downtime={this.props.newEvent}
        />
      </div>
    )
  }
}

export default DownTimeTimeOnInput
